<template>
  <b-form-group id="dropdown-mtxf7q" :label="properties.label">
    <b-select id="dropdown-007ntf"
      size="sm"
      v-model="propertyValue"
      :options="properties.options"
    ></b-select>
  </b-form-group>
</template>

<script>
export default {
  name: "TextAreaPropertyType",
  props: ["properties", "property", "value", "options"],
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
        if(this.properties.updateAiLabel){
          
          this.$emit("update-value", "label", newValue.toLowerCase()
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, l => l.toUpperCase()
                    )
          );  
        }
      }
    }
  }
};
</script>
